import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromSubform from './subform.reducer';
import * as fromOptions from './select-field-options.reducer';
import * as fromFormEditor from './form-editor.reducer';

export interface FormsState {
    subforms: fromSubform.State;
    options: fromOptions.State;
    formEditor: fromFormEditor.State;
}

export interface State {
    'forms': FormsState;
}

export const reducers: ActionReducerMap<any> = {
    subforms: fromSubform.reducer,
    options: fromOptions.reducer,
    formEditor: fromFormEditor.reducer
};

export const getFormsState = createFeatureSelector<FormsState>('forms');

export const getSubforms = createSelector(
    getFormsState,
    state => state.subforms
);

export const getOptions = createSelector(
    getFormsState,
    state => state.options
);

export const getFormEditor = createSelector(
    getFormsState,
    state => state.formEditor
);



// WEBPACK FOOTER //
// ./src/app/forms/state/reducers.ts